import * as actionTypes from "./actionTypes";
import * as programService from "./service";
import { applyFilter } from "../../utils/general";

const log = require("loglevel").getLogger("ProgramActions");
log.setLevel("error");

export const loadProgramById = (id) => {
  return async (dispatch) => {
    log.debug("ProgramActions -> loadProgramById -> Enter");

    const program = await programService.loadProgramById(id);

    await dispatch({
      type: actionTypes.PROGRAM_LOADED,
      data: program,
    });
  };
};

export const loadPrograms = (selectedFilters, forceReload) => {
  return async (dispatch) => {
    log.debug("ProgramActions -> loadPrograms -> Enter");

    const result = await programService.loadPrograms(
      selectedFilters,
      forceReload
    );

    const records = result?.data?.records ?? [];
    const lastUpdated = result?.data?.lastUpdated;

    let filteredPrograms = records;

    selectedFilters?.forEach((filter) => {
      filteredPrograms = applyFilter(filteredPrograms, filter);
    });

    await dispatch({
      type: actionTypes.PROGRAMS_LOADED,
      data: filteredPrograms,
      lastUpdated,
    });
  };
};
